import React from "react"
import { isEmpty } from "lodash"
import { useAiChatbotContext } from '../../../../contexts/aiChatbotContext'
import ChatBubble from "../../../shared/chatBubble"

const ChatBox = () => {
  const { messages, loadingMessage } = useAiChatbotContext()

  return (
    <div className="flex flex-col gap-y-4 max-w-6xl w-full h-full overflow-scroll">
      { isEmpty(messages) && (
        <div className="h-full w-full flex justify-center items-center">
          <p className="font-bold text-4xl">Select a Prompt Collection to see chat</p>
        </div>
      ) }
      { messages.map((message, i) => <ChatBubble key={ i } message={ message }/>) }
      { loadingMessage && (
        <div className="w-full flex justify-center items-center">
          <div className="loader"></div>
        </div>
      ) }
      <div className="overflow-anchor h-px"></div>
    </div>
  )
}

export default ChatBox
